import { type CouponIdentifiers, couponValidator } from '../../../../schema/coupon/entry.js';
import type { IUpdateCouponUseCase } from '../../../domain/entry.js';

export type IUpdateCouponController = ReturnType<typeof updateCouponController>;

// Map values to "unknown" to be more API-like
// type CouponPayload = {
//   [K in keyof ReturnType<typeof couponValidator.parse>]: unknown;
// };

type UpdateCouponPayloadParams = ReturnType<typeof couponValidator.parse>;

/**
 * Controller for updating a coupon.
 *
 * @param updateCouponUseCase Use case for updating a coupon
 * @returns Controller executor function
 */
export function updateCouponController(updateCouponUseCase: IUpdateCouponUseCase) {
  return async function controller(
    payload: UpdateCouponPayloadParams,
    { couponId, couponIndex }: CouponIdentifiers
  ): Promise<number> {
    const parsedPayload = couponValidator.parse(payload);
    return await updateCouponUseCase.execute({ couponId, couponIndex, payload: parsedPayload });
  };
}
